var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"menu-nav"},_vm._l((_vm.menuItems),function(item){return _c('li',{key:item.id,staticClass:"menu-item"},[_c('router-link',{staticClass:"menu-link",attrs:{"to":{ name: item.page }}},[_vm._v(_vm._s(item.title))])],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }